import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../api/client";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      navigate("/login");
      return;
    }

    // Check expiry locally first (fast path)
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (Date.now() >= payload.exp * 1000) {
        // Try refresh
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("no refresh token");

        api.post("/api/auth/refresh", { refreshToken })
          .then(({ data }) => {
            localStorage.setItem("accessToken", data.accessToken);
            setReady(true);
          })
          .catch(() => {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            Swal.fire({ icon: "warning", title: "Sesi Berakhir", text: "Silakan login kembali.", confirmButtonText: "OK" })
              .then(() => navigate("/login"));
          });
        return;
      }
    } catch {
      navigate("/login");
      return;
    }

    setReady(true);
  }, [navigate]);

  if (!ready) return <div className="min-h-screen bg-gray-900 flex items-center justify-center text-white">Loading...</div>;

  return children;
};

export default ProtectedRoute;
